/**
 * AUFTRAG-95 (21.10.2026): Die Adresse folgt der Auswahl, damit sich genau diese Ausführung als Link teilen lässt.
 *
 * Teil A (unsichtbar): Jede Auswahl-Änderung schreibt die Konfiguration per history.replaceState in die Adresse
 * (kein neuer Verlaufseintrag, "Zurück" bleibt wie vorher). Beim Laden wird sie von den Seiten-Skripten wiederhergestellt.
 * Teil B: Knopf [data-auswahl-copy] (snippets/auswahl-link.liquid) kopiert den Link samt Konfiguration.
 *
 * Parameter-Schema (alle optional, Unbekanntes oder Ungültiges fällt still auf den Standard zurück):
 *   variant=<Varianten-ID>        gewählte Variante (Shopify-Standard; ungültig = Standardvariante)
 *   z=<Teil>[~<SKU>],<Teil>…      angehakte Zubehörteile: Produkt-Handle, bei mehreren Ausführungen ~ und SKU der Ausführung
 *   q=<Zahl>                      Menge (nur wenn größer als 1)
 *   p=<Zahl>                      gewählte Position (Draufsicht bzw. Lagersystem), 1-basiert
 * Der Sprachpräfix (/it/…) und der Produkt-Pfad bleiben unverändert. canonical zeigt weiter auf die Adresse ohne Parameter.
 *
 * Gemeinsame Logik für alle Produktvorlagen: Seiten melden ihren Zustand mit CryonosAuswahl.register(fn), fn() liefert
 * {schlüssel: wert|null}. Keine Handles im Code.
 */
(function () {
  if (window.CryonosAuswahl) return;
  var KEYS = ['variant', 'z', 'q', 'p'];
  var providers = [];

  function rawPairs() {
    var s = (window.location.search || '').replace(/^\?/, '');
    return s ? s.split('&') : [];
  }
  function pairKey(p) { var i = p.indexOf('='); try { return decodeURIComponent(i < 0 ? p : p.slice(0, i)); } catch (e) { return p; } }
  /** Wert eines verwalteten Schlüssels aus der Adresse (decodiert) oder null. */
  function read(key) {
    var pairs = rawPairs();
    for (var i = 0; i < pairs.length; i++) {
      if (pairKey(pairs[i]) === key) {
        var j = pairs[i].indexOf('=');
        if (j < 0) return '';
        try { return decodeURIComponent(pairs[i].slice(j + 1).replace(/\+/g, ' ')); } catch (e) { return null; }
      }
    }
    return null;
  }
  /** z-Liste: [{h: handle, s: sku|null}] */
  function readList(key) {
    var v = read(key);
    if (!v) return [];
    var out = [];
    v.split(',').forEach(function (t) {
      t = t.trim();
      if (!t) return;
      var k = t.indexOf('~');
      out.push({ h: k < 0 ? t : t.slice(0, k), s: k < 0 ? null : t.slice(k + 1) });
    });
    return out;
  }
  function readInt(key) {
    var v = read(key);
    var n = v == null ? NaN : parseInt(v, 10);
    return n > 0 ? n : null;
  }
  function itemStr(h, s) { return encodeURIComponent(h) + (s ? '~' + encodeURIComponent(s) : ''); }

  function register(fn) { if (typeof fn === 'function') providers.push(fn); }
  function collect() {
    var out = {};
    providers.forEach(function (fn) {
      var r;
      try { r = fn() || {}; } catch (e) { r = {}; }
      KEYS.forEach(function (k) {
        if (Object.prototype.hasOwnProperty.call(r, k)) out[k] = r[k];
      });
    });
    return out;
  }
  function queryOf(vals, keepOthers) {
    var parts = [];
    if (keepOthers) rawPairs().forEach(function (p) { if (KEYS.indexOf(pairKey(p)) < 0) parts.push(p); });
    KEYS.forEach(function (k) {
      var v = vals[k];
      if (v == null || v === '') return;
      parts.push(k + '=' + (k === 'z' ? v : encodeURIComponent(v)));
    });
    return parts.length ? '?' + parts.join('&') : '';
  }
  function hasManaged() { return rawPairs().some(function (p) { return KEYS.indexOf(pairKey(p)) > -1; }); }
  /** Schreibt den Zustand in die Adresse. force=false: nur, wenn die Adresse schon Parameter trägt (Normalisierung beim Laden). */
  function update(force) {
    if (!force && !hasManaged()) return;
    try {
      var q = queryOf(collect(), true);
      history.replaceState(history.state, '', window.location.pathname + q + window.location.hash);
    } catch (e) { /* ohne Adresszeile weiter */ }
  }
  /** Link mit voller Konfiguration (ohne fremde Parameter wie preview_theme_id, ohne Anker). */
  function link() {
    return window.location.origin + window.location.pathname + queryOf(collect(), false);
  }

  window.CryonosAuswahl = { register: register, update: update, link: link, read: read, readList: readList, readInt: readInt, itemStr: itemStr };

  /* Standard-Variantenwahl (variant-picker.js): Variante aus dem versteckten Formularfeld. */
  register(function () {
    var el = document.querySelector('input[data-variant-id-input]');
    return el && el.value ? { variant: el.value } : {};
  });
  document.addEventListener('variant:changed', function () { update(true); });
  window.addEventListener('load', function () { update(false); });
  document.addEventListener('freezer:ready', function () { update(false); });

  function copyText(t) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t).catch(function () { return legacyCopy(t); });
    return legacyCopy(t);
  }
  function legacyCopy(t) {
    return new Promise(function (ok, fail) {
      var ta = document.createElement('textarea');
      ta.value = t;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var done = false;
      try { done = document.execCommand('copy'); } catch (err) { done = false; }
      document.body.removeChild(ta);
      if (done) ok(); else fail();
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-auswahl-copy]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-auswahl]') || btn.parentNode;
    var ok = box.querySelector('[data-auswahl-ok]');
    var text = link();
    btn.setAttribute('data-auswahl-url', text);
    copyText(text).then(function () {
      if (!ok) return;
      ok.textContent = ok.getAttribute('data-text') || 'copied';
      clearTimeout(ok._t);
      ok._t = setTimeout(function () { ok.textContent = ''; }, 2500);
    }, function () { /* Kopieren nicht möglich: Adresse steht in der Adresszeile */ });
  });
})();
